export const showWarningIcon = percentage => {
  return Number(percentage) < 90
}

export const getColorByPercentage = (percentage, theme) => {
  if (Number(percentage) < 70) {
    return {
      normal: theme.colors.danger.default,
      soft: theme.colors.danger.surface,
      gradient: 'linear-gradient(90deg, #ff6b6b 20.49%, #ff3d3d 102.45%)',
    }
  }

  if (Number(percentage) < 90) {
    return {
      normal: theme.colors.accent.hover,
      soft: theme.colors.warning.surface,
      gradient: 'linear-gradient(90deg, #ffb366 20.49%, #ff8c00 102.45%)',
    }
  }

  if (Number(percentage) < 100) {
    return {
      normal: theme.colors.success.onSurface,
      soft: theme.colors.success.surface,
      gradient: 'linear-gradient(90deg, #68fbc9 20.49%, #34d69f 102.45%)',
    }
  }

  return {
    normal: theme.colors.success.default,
    soft: theme.colors.success.surface,
    gradient: 'linear-gradient(90deg, #68fbc9 20.49%, #34d69f 102.45%)',
  }
}
